import { OnInit } from '@angular/core';
import { QuestionActionService } from '../services/question-action.service';
import { CopyClipboardService } from 'app/shared/services/copy-clipboard.service';
var ScaleQuestionsListComponent = /** @class */ (function () {
    function ScaleQuestionsListComponent(actionService, copyClipboardService) {
        this.actionService = actionService;
        this.copyClipboardService = copyClipboardService;
        this.hasThirdColumn = false;
        this.hasQuestionActions = true;
        // by default flag the prompts
        this.flagPrompts = true;
        this.hasThirdColumn = false;
        this.hasQuestionActions = false;
        this.displayScale = false;
        this.QuestionActions = [];
    }
    ScaleQuestionsListComponent.prototype.ngOnInit = function () {
        var _this = this;
        var actionsByQuestionId = (this.QuestionActions || []).reduce(function (prev, curr) { prev[curr.question.id] = curr; return prev; }, {});
        if (this.QuestionActions && this.QuestionActions.length) {
            this.hasQuestionActions = true;
            this.hasThirdColumn = true;
        }
        this.QuestionDisplays = this.Questions.map(function (q) {
            var display = { prompt: q.prompt, answerDisplayText: q.answerDisplayText, scale: q.assessment_scale.name };
            if (actionsByQuestionId[q.id]) {
                display.action = actionsByQuestionId[q.id];
                display.actionLabel = display.action.label;
            }
            display.isFlaggedForReview = _this.flagQuestion(q);
            display.computedScore = q.getComputedScore();
            return display;
        });
        this.hasThirdColumn = this.displayScale == true;
    };
    ScaleQuestionsListComponent.prototype.copyTable = function () {
        var _this = this;
        /**
         * <div class="cell-data col-8 col-md-9" *ngIf="!HasThirdColumn">Question</div>
            <div class="cell-data col-4 col-md-3" *ngIf="!HasThirdColumn">Answer</div>
    
            <div class="cell-data col-7 col-md-8" *ngIf="HasThirdColumn">Question</div>
            <div class="cell-data col-2 col-md-2" *ngIf="HasThirdColumn">Answer</div>
            <div class="cell-data col-2 col-md-2" *ngIf="HasThirdColumn && hasQuestionActions">Action</div>
            <div class="cell-data col-2 col-md-2" *ngIf="HasThirdColumn && displayScale">Scale</div>
         */
        var copyTable = [];
        copyTable.push(["Question", "Answer"]);
        if (this.hasThirdColumn && this.displayScale) {
            copyTable[0].push("Scale");
        }
        if (this.QuestionDisplays.length) {
            this.QuestionDisplays.forEach(function (qd) {
                var row = [];
                row.push('"' + qd.prompt + '"');
                row.push('"' + qd.answerDisplayText + '"');
                if (_this.hasThirdColumn && _this.displayScale) {
                    row.push('"' + qd.scale + '"');
                }
                copyTable.push(row);
            });
        }
        this.copyClipboardService.copyTableToText(copyTable);
    };
    Object.defineProperty(ScaleQuestionsListComponent.prototype, "HasThirdColumn", {
        get: function () {
            return this.hasThirdColumn;
        },
        enumerable: true,
        configurable: true
    });
    ScaleQuestionsListComponent.prototype.shouldDisplayScale = function (scale) {
        return this.displayScale === true;
    };
    ScaleQuestionsListComponent.prototype.shouldDisplayEmptyActionColumn = function (question) {
        if (!this.displayScale && this.hasQuestionActions) {
            return question.action === "" || question.action === undefined;
        }
        return false;
    };
    ScaleQuestionsListComponent.prototype.shouldDisplayActionColumn = function (question) {
        if (!this.displayScale && this.hasQuestionActions) {
            return question.action !== "" && question.action !== undefined;
        }
        return false;
    };
    ScaleQuestionsListComponent.prototype.flagQuestion = function (question) {
        return this.flagPrompts && question.isFlaggedForReview;
    };
    ScaleQuestionsListComponent.prototype.handleAction = function (questionDisplay) {
        console.log("Handling action: ", questionDisplay.action);
        this.actionService.handleAction(questionDisplay.action);
    };
    return ScaleQuestionsListComponent;
}());
export { ScaleQuestionsListComponent };



// WEBPACK FOOTER //
// ./src/app/reports/scale-questions-list/scale-questions-list.component.ts.pre-build-optimizer.js